import type { Property } from '~/core/entities/property';

import { useEvents } from '~/composables/events/useEvents';
import { MixpanelProps } from '~/core/service/mixpanel';
import { PropertyFiltersPresenter } from '~/presenters/PropertyFiltersPresenter';

interface UsePropertyHeroNavigationOptions {
	property: Ref<Property | null>;
}

export function usePropertyHeroNavigation({
	property
}: UsePropertyHeroNavigationOptions) {
	const router = useRouter();
	const { trackReturnPropertyDetails, trackSearchBarClicked } = useEvents();

	function handleBackButtonClick() {
		const filters = PropertyFiltersPresenter.createLocationFilters({
			regions: [property.value?.region ?? ''],
			states: [property.value?.state ?? ''],
			cities: [property.value?.city ?? '']
		});

		const path = PropertyFiltersPresenter.getPathFromFilters(filters);

		trackReturnPropertyDetails({
			[MixpanelProps.CURRENT_PAGE]: 'Property Details',
			[MixpanelProps.COMMERCIAL_ID]: property.value?.commercialId ?? '',
			[MixpanelProps.NEIGHBORHOODS_NAME]: property.value?.region ?? '',
			[MixpanelProps.DESTINATION_URL]: path
		});

		router.push(path);
	}

	function handleSearchBarClick() {
		trackSearchBarClicked({
			[MixpanelProps.CURRENT_PAGE]: 'Property Details',
			[MixpanelProps.COMMERCIAL_ID]: property.value?.commercialId ?? ''
		});
	}

	return {
		handleBackButtonClick,
		handleSearchBarClick
	};
}
